<template>
  <div>
    <div class="card card-primary card-outline">
      <div class="card-header">
        <h3 class="card-title">Hızlı İşlemler</h3>
      </div>
      <!-- /.card-header -->
      <div class="card-body table-responsive" >
        <div class="row">
          <div
            class="col-4"
            style="
              border-right: 1px solid #ddd;
              border-bottom: 2px solid #ddd;
              padding: 10px;
            "
          >
            <label>Bonus Talep</label>
            <div class="input-group input-group-sm">
              <select class="form-control" v-model="bonus">
                <option :value="0">Bonus Seçiniz</option>
                <option v-for="data in bonuses" :key="data.id" :value="data.id">
                  {{ data.name }}
                </option>
              </select>
              <span class="input-group-append">
                <button
                  type="button"
                  @click="requestBonus"
                  class="btn btn-primary btn-flat"
                >
                  Talep Et
                </button>
              </span>
            </div>
          </div>
          <div
            class="col-4"
            style="
              border-left: 1px solid #ddd;
              border-right: 1px solid #ddd;
              border-bottom: 2px solid #ddd;
              padding: 10px;
            "
          >
            <label>Yatırım Sil</label>
            <div class="input-group input-group-sm">
              <input
                class="form-control"
                v-model="transaction"
                placeholder="Transactins IDs"
              />

              <span class="input-group-append">
                <button
                  type="button"
                  @click="deleteDeposit"
                  class="btn btn-primary btn-flat"
                >
                  Talep Et
                </button>
              </span>
            </div>
          </div>
          <div
            class="col-4"
            style="
              border-left: 1px solid #ddd;
              border-bottom: 2px solid #ddd;
              padding: 10px;
            "
          >
            <label>Tc Kontrol</label>
            <div class="input-group input-group-sm">
              <input
                class="form-control"
                v-model="tckn"
                placeholder="Tc Kimlik no giriniz"
              />

              <span class="input-group-append">
                <button
                  type="button"
                  @click="tcControl"
                  class="btn btn-primary btn-flat"
                >
                  Talep Et
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- /.card-body -->
    </div>

    <div class="card card-primary card-outline">
      <div class="card-header">
        <h3 class="card-title">Müşteri İzinleri</h3>
      </div>
      <!-- /.card-header -->
      <div class="card-body table-responsive">
        <div class="row">
          <div class="col-2">
            <button
              style="margin: 10px 0"
              class="btn btn-sm form-control"
              :class="{
                'btn-success': permitions.vip == 1,
                'btn-danger': permitions.vip != 1,
              }"
            >
              {{ permitions.vip == 1 ? "Vip Müşteri" : "Normal Müşteri" }}
            </button>
          </div>
          <div class="col-2">
            <button
              style="margin: 10px 0"
              class="btn btn-sm form-control"
              :class="{
                'btn-success': permitions.bet == 1,
                'btn-danger': permitions.bet != 1,
              }"
            >
              {{ permitions.bet == 1 ? "Kupon Yapabilir" : "Kupon Yamamaz" }}
            </button>
          </div>
          <div class="col-2">
            <button
              style="margin: 10px 0"
              class="btn btn-sm form-control"
              :class="{
                'btn-success': permitions.deposit == 1,
                'btn-danger': permitions.deposit != 1,
              }"
            >
              {{
                permitions.deposit == 1
                  ? "Para Yatırabilir"
                  : "Para Yatırabilir"
              }}
            </button>
          </div>
          <div class="col-2">
            <button
              style="margin: 10px 0"
              class="btn btn-sm form-control"
              :class="{
                'btn-success': permitions.withdraw == 1,
                'btn-danger': permitions.withdraw != 1,
              }"
            >
              {{
                permitions.withdraw == 1 ? "Çekim Yapabilir" : "Çekim Yapamaz"
              }}
            </button>
          </div>
          <div class="col-2">
            <button
              style="margin: 10px 0"
              class="btn btn-sm form-control"
              :class="{
                'btn-success': permitions.transfer == 1,
                'btn-danger': permitions.transfer != 1,
              }"
            >
              {{
                permitions.transfer == 1
                  ? "Transfer Yapabilir"
                  : "Transfer Yapamaz"
              }}
            </button>
          </div>
          <div class="col-2">
            <button
              style="margin: 10px 0"
              class="btn btn-sm form-control"
              :class="{
                'btn-success': permitions.feed == 1,
                'btn-danger': permitions.feed != 1,
              }"
            >
              {{
                permitions.feed == 1 ? "Haber Alabilir" : "Haber Alamaz"
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["customer"],
  data() {
    return {
      bonuses: [],
      permitions: {
        vip: null,
        deposit: null,
        bet: null,
        login: null,
        witdraw: null,
        transfer: null,
        feed: null,
      },
      bonus: 0,
      manuel: 0,
      tckn: "",
      transaction: "",
    };
  },
  methods: {
    getPermitions() {
      this.$http
        .get("Customer/CustomerPermitions/" + this.customer.code)
        .then((response) => {
          this.permitions = response.data;
        });
    },
    getAllBonus() {
      this.$http.get("Bonus/ListAllBonuses/").then((response) => {
        this.bonuses = response.data;
      });
    },
    deleteDeposit() {
      this.$http
        .post("Finance/DeleteDeposit/", {
          code: this.customer.code,
          transaction: this.transaction,
        })
        .then(
          (response) => {
            toastr.success("Yatırım kayıtları başarıyla silindi.");
            this.transaction = "";
          },
          (err) => {
            toastr.error(
              "İşlem sırasında bir hata oluştu! Lütfen tekrar deneyiniz."
            );
          }
        );
    },
    requestBonus() {
      this.$http
        .post("Bonus/RequestBonus/", {
          bonus: this.bonus,
          customer: this.customer.id,
        })
        .then(
          (response) => {
            toastr.success("Bonus talebiniz başarıyla alındı.");
            this.bonus = 0;
          },
          (err) => {
            toastr.error(
              "İşlem sırasında bir hata oluştu! Lütfen tekrar deneyiniz."
            );
          }
        );
    },
    tcControl() {
      this.$http
        .post("Customer/TcControlQuick", {
          code: this.customer.code,
          tckn: this.tckn,
        })
        .then(
          (response) => {
            toastr.success(response.data);

            this.tckn = "";
          },
          (err) => {
            toastr.error(err.data.Message);
          }
        );
    },
    requestManuelBonus() {},
  },
  created() {
    this.getAllBonus();
    this.getPermitions();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Customer/CustomerQuick.vue